/* eslint-disable no-undef */
/* eslint-disable camelcase */
/**
 * Page: Hosting Backups.
 *
 * @param {jQuery} $ Reference to jQuery object.
 */
( function( $ ) {
	function get_hosting_backups( page ) {
		const deferred = $.Deferred();

		const request_data = {
			action: 'snapshot-list_hosting_backups',
			_wpnonce: $( '#_wpnonce-list-hosting-backups' ).val(),
			page
		};

		$.ajax( {
			type: 'POST',
			url: ajaxurl,
			data: request_data,
			cache: false,
			success( response ) {
				if ( response.success ) {
					deferred.resolve( response.data );
				} else {
					deferred.reject();
				}
			},
			error() {
				deferred.reject();
			}
		} );

		return deferred.promise();
	}

	function load_hosting_backups( page ) {
		const lists = [
			'.snapshot-hosting-backups-backups .snapshot-backup-list-loader',
		];

		const api_error = $( '.snapshot-hosting-backups-backups .api-error' );
		const no_backups = document.querySelector( '.snapshot-hosting-backups-backups .snapshot-no-hosting-backup' );
		const api_error_elements = $( '.snapshot-page-hosting-backups' ).find( [
			'.snapshot-hosting-backup-count',
			'.snapshot-last-hosting-backup',
			'.snapshot-next-hosting-backup',
			'.snapshot-hosting-backup-schedule',
		].join( ',' ) );
		const table = $( '.snapshot-hosting-backups-backups .snapshot-hosting-backups-table' );

		const tbody = $( table ).find( '>tbody' );
		tbody.empty();

		if ( typeof page === 'undefined' ) {
			api_error_elements.empty();
			lists.push( '.snapshot-page-hosting-backups .snapshot-loading' );
		}

		const loaders = $( lists.join( ',' ) );

		loaders.show();
		api_error.hide();
		table.hide();

		get_hosting_backups( page ).then( function( data ) {
			api_error.hide();

			if ( typeof page === 'undefined' ) {
				$( '.snapshot-page-hosting-backups .snapshot-hosting-backup-count' ).text( data.total_backups );
				$( '.snapshot-page-hosting-backups .snapshot-last-hosting-backup' ).text( data.last_backup_time );
				$( '.snapshot-page-hosting-backups .snapshot-next-hosting-backup' ).text( data.next_backup_time );
				$( '.snapshot-page-hosting-backups .snapshot-hosting-backup-schedule' )
					.append( '<span class="sui-icon-lock" style="margin-right: 5px;" aria-hidden="true"></span>' )
					.append( $( '<span></span>' ).text( data.backup_schedule ) )
					.attr( 'data-tooltip', data.backup_schedule_tooltip )
				;
			}

			$( '.snapshot-page-hosting-backups .render-pagination-top' ).html( data.pagination.html );
			$( '.snapshot-page-hosting-backups .render-pagination' ).html( data.pagination.html );

			data.backups.forEach( function( item ) {
				tbody.append( item.html_row );
			} );
			table.show();
		}, function() {
			if ( no_backups ) {
				no_backups.style.display = 'none';
			}
			api_error.show();
			api_error_elements.text( '-' );
		} ).always( function() {
			loaders.hide();
		} );
	}

	function download_hosting_backup( backup_id ) {
		const request_data = {
			action: 'snapshot-download_hosting_backup',
			_wpnonce: $( '#_wpnonce-download-hosting-backup' ).val(),
			backup_id
		};

		$.ajax( {
			type: 'POST',
			url: ajaxurl,
			data: request_data,
			cache: false,
			success( response ) {
				const notice = $( '<span></span>' );
				let type = 'success';
				if ( response.success ) {
					notice.html( response.data.notice_html );
				} else {
					type = 'error';
					notice.html( snapshot_messages.backup_export_error );
				}
				jQuery( window ).trigger( 'snapshot:show_top_notice', [ type, notice ] );
			},

			error() {
				const notice = $( '<span></span>' ).html( snapshot_messages.backup_export_error );
				jQuery( window ).trigger( 'snapshot:show_top_notice', [ 'error', notice ] );
			}
		} );
	}

	$( function() {
		if ( $( '.snapshot-page-hosting-backups' ).length ) {
			$( '.snapshot-hosting-backups-backups .reload-backups' ).on( 'click', load_hosting_backups );
			load_hosting_backups();

			$( '.snapshot-hosting-backups-table' ).on( 'click', '.download-hosting-backup', function() {
				const backup_id = $( this ).data( 'backupId' );
				download_hosting_backup( backup_id );
			} );
		}

		const getPageNumber = function( url ) {
			const params = new URLSearchParams( url );
			return parseInt( params.get( 'paged' ) );
		};

		const hostingBackups = document.querySelector( '.snapshot-hosting-backups-backups' );

		if ( hostingBackups ) {
			hostingBackups.addEventListener( 'click', function( e ) {
				let el = e.target;
				if ( el.classList.contains( 'page-numbers' ) || el.parentNode.classList.contains( 'page-numbers' ) ) {
					e.preventDefault();

					if ( el.parentNode.classList.contains( 'page-numbers' ) ) {
						el = el.parentNode;
					}

					if ( el.classList.contains( 'dots' ) ) {
						return;
					}

					const pageNumber = getPageNumber( el.getAttribute( 'href' ) );
					load_hosting_backups( pageNumber );
				}
			} );
		}
	} );
}( jQuery ) );

